export default {
  postTextQuery: '/df_text_query',
  postEventQuery: '/df_event_query',
};
